import React from 'react';
import {
  ACLAction,
  ACLContentType,
  ACLContentTypeValues,
  ACLUSer,
} from 'v2/models';
import { Table } from 'react-bootstrap';
import classnames from 'classnames';
import styles from './reviewPermissionsModal.module.scss';
import _ from 'lodash';
import PermissionItem from './PermissionItem';
import { Controller, useFormContext } from 'react-hook-form';

interface PermissionsFormProps {
  accessControls: ACLUSer[];
}

export type ACLByEntityType = {
  [key: string]: {
    [key: string]: ACLUSer;
  };
};

export interface PermissionsChangesField {
  accessControls: ACLByEntityType;
}

const PermissionsForm = ({ accessControls }: PermissionsFormProps) => {
  const { control, watch } = useFormContext<PermissionsChangesField>();
  const initialState = accessControls.reduce((group: ACLByEntityType, item) => {
    group[item.content_type.model] = {
      ...group[item.content_type.model],
      [item.action]: item,
    };
    return group;
  }, {});

  const aclByEntity = watch('accessControls', initialState);

  return (
    <>
      <Table className={classnames(styles.table)} bordered={false}>
        <thead>
          <tr>
            <th>object</th>
            {Object.values(ACLAction).map((action) => (
              <th key={action}>{action}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.keys(aclByEntity).map((objectType) => {
            const acl = aclByEntity[objectType];
            const object = ACLContentTypeValues[objectType as ACLContentType];
            return (
              <tr key={`row_${object.replaceAll(' ', '_')}`}>
                <td>
                  <p>{object}</p>
                </td>
                {Object.values(ACLAction).map((action) => {
                  const key = `acl_${objectType}_${action}`;
                  return (
                    <td key={`${key}_td`} data-testid={`${action}_td`}>
                      <Controller
                        name="accessControls"
                        control={control}
                        rules={{
                          required: true,
                          validate: (aclByEntity) =>
                            !_.isEqual(initialState, aclByEntity),
                        }}
                        render={({ field: { onChange } }) => {
                          return (
                            <PermissionItem
                              acl={acl[action]}
                              aclByEntity={aclByEntity}
                              keyValue={key}
                              onChange={onChange}
                            />
                          );
                        }}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default PermissionsForm;
